import { useNavigate } from "react-router";
import { router } from "../../core/helpers/router";
import FirebaseKey from "../FirebaseKey/FirebaseKey";

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
  anchorPosition?: { top: number; right: number };
}

const Menu = ({ isOpen, onClose, anchorPosition }: MenuProps) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "wallet",
      firebaseKey: "menu_wallet",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 14V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V14M22 14C22 13.4477 21.5523 13 21 13H18.4043C18.1449 13 17.8962 13.1026 17.7047 13.2776C14.0562 16.6118 10.1534 16.6421 6.29126 13.2615C6.10249 13.0963 5.86076 13 5.60989 13H3C2.44772 13 2 13.4477 2 14M22 14V10.5C22 9.39543 21.1046 8.5 20 8.5H4C2.89543 8.5 2 9.39543 2 10.5V14M2 11V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V11"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      path: "https://jdmt.adj.st/?adj_t=1c5ry371",
      isExternal: true,
      postFix: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5612_4210)">
            <path
              d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
              fill="#807E7D"
              fillOpacity="0.12"
            />
            <path
              d="M16.9998 14L22.9999 20L16.9998 26"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_5612_4210">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: "faq",
      firebaseKey: "menu_faq",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V3C11.25 3.41421 11.5858 3.75 12 3.75C12.4142 3.75 12.75 3.41421 12.75 3V2Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.49197 9.28232C7.15867 7.08312 9.01832 5.25 11.9994 5.25C14.9803 5.25 16.8402 7.08288 17.5072 9.28193C18.1586 11.4295 17.6985 14.0079 16.0202 15.6242C15.7554 15.8792 15.5886 16.1118 15.5178 16.341C15.4172 16.6666 15.3191 17.0006 15.228 17.3205C14.8256 18.7334 13.5433 19.75 12.048 19.75H11.9519C10.4565 19.75 9.1744 18.7333 8.77177 17.3207C8.68051 17.0006 8.58222 16.6664 8.48143 16.3405C8.41062 16.1117 8.24397 15.8793 7.97949 15.6246C6.30128 14.0085 5.84087 11.43 6.49197 9.28232ZM7.92745 9.71749C7.41221 11.4171 7.81203 13.3809 9.01998 14.5442C9.36409 14.8756 9.73554 15.319 9.91443 15.8973C10.0193 16.2362 10.1208 16.5814 10.2143 16.9096C10.4406 17.7034 11.1529 18.25 11.9519 18.25H12.048C12.847 18.25 13.5593 17.7034 13.7853 16.9097C13.8787 16.5818 13.98 16.2369 14.0846 15.8983C14.2634 15.3194 14.6352 14.8755 14.9797 14.5438C16.1877 13.3804 16.5872 11.4168 16.0718 9.71731C15.5719 8.06928 14.2384 6.75 11.9994 6.75C9.76036 6.75 8.4271 8.06936 7.92745 9.71749Z"
            fill="black"
          />
          <path
            d="M13.9743 21.077L14 21H10L10.0257 21.077C10.3089 21.9268 11.1042 22.5 12 22.5C12.8958 22.5 13.6911 21.9268 13.9743 21.077Z"
            fill="black"
          />
          <path
            d="M19.25 11C19.25 10.5858 19.5858 10.25 20 10.25H21C21.4142 10.25 21.75 10.5858 21.75 11C21.75 11.4142 21.4142 11.75 21 11.75H20C19.5858 11.75 19.25 11.4142 19.25 11Z"
            fill="black"
          />
          <path
            d="M3 10.25C2.58579 10.25 2.25 10.5858 2.25 11C2.25 11.4142 2.58579 11.75 3 11.75H4C4.41421 11.75 4.75 11.4142 4.75 11C4.75 10.5858 4.41421 10.25 4 10.25H3Z"
            fill="black"
          />
          <path
            d="M16.9697 6.03033C16.6768 5.73744 16.6768 5.26256 16.9697 4.96967L17.8338 4.10554C18.1267 3.81265 18.6016 3.81265 18.8945 4.10554C19.1873 4.39844 19.1873 4.87331 18.8945 5.1662L18.0303 6.03033C17.7374 6.32322 17.2626 6.32322 16.9697 6.03033Z"
            fill="black"
          />
          <path
            d="M5.96967 6.03033C6.26256 6.32322 6.73744 6.32322 7.03033 6.03033C7.32322 5.73744 7.32322 5.26256 7.03033 4.96967L6.1662 4.10554C5.87331 3.81265 5.39844 3.81265 5.10554 4.10554C4.81265 4.39844 4.81265 4.87331 5.10554 5.1662L5.96967 6.03033Z"
            fill="black"
          />
        </svg>
      ),
      path: router.FAQ,
      isExternal: false,
    },
    {
      id: "contact",
      firebaseKey: "menu_contact",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
            fill="black"
          />
          <path
            d="M11.6644 7.73117C12.2836 7.59204 12.8967 7.62141 13.3649 7.81201C13.8057 7.99146 14.1354 8.31553 14.2724 8.86334C14.385 9.31367 14.2319 9.829 13.8716 10.3555C13.5153 10.8762 13.0358 11.2855 12.7504 11.4621L12.739 11.4691C12.6515 11.5232 12.5145 11.6079 12.3858 11.7171C11.918 12.1141 11.5748 12.4878 11.3996 12.998C11.2491 13.4361 11.2495 13.9201 11.25 14.4183L11.25 14.4995C11.25 14.9137 11.5858 15.2495 12 15.2495C12.4142 15.2495 12.75 14.9137 12.75 14.4995C12.75 13.8802 12.7591 13.6574 12.8182 13.4854C12.8607 13.3616 12.9531 13.203 13.3564 12.8608C13.3911 12.8313 13.4377 12.8008 13.5397 12.7376C13.9955 12.4556 14.6303 11.9028 15.1095 11.2026C15.5848 10.5081 15.9886 9.54357 15.7276 8.49954C15.4646 7.44735 14.7745 6.76633 13.9304 6.42271C13.1137 6.09026 12.1769 6.07862 11.3356 6.26766C9.53775 6.67165 8.25 8.1163 8.25 9.99942C8.25 10.4136 8.58579 10.7494 9 10.7494C9.41421 10.7494 9.75 10.4136 9.75 9.99942C9.75 8.88252 10.4863 7.99591 11.6644 7.73117Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"
            fill="black"
          />
        </svg>
      ),
      path: router.CONTACT,
      isExternal: false,
    },
    {
      id: "agreement",
      firebaseKey: "menu_agreement",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 2.5V7.5C13.5 8.05228 13.9477 8.5 14.5 8.5H19.5M8 14H16M8 18H16M19.1213 7.12132L14.8787 2.87868C14.3161 2.31607 13.553 2 12.7574 2H7C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9.24264C20 8.44699 19.6839 7.68393 19.1213 7.12132Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ),
      path: router.AGREEMENT,
      isExternal: false,
    },
  ];

  const handleMenuItemClick = (path: string, isExternal: boolean) => {
    if (isExternal) {
      window.location.href = path;
    } else {
      navigate(path);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[200] transition-opacity"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-[201] p-4" onClick={onClose}>
        <div
          className="bg-white rounded-3xl shadow-2xl w-max max-w-sm transform transition-all absolute"
          onClick={(e) => e.stopPropagation()}
          style={
            anchorPosition
              ? {
                top: `${anchorPosition.top}px`,
                right: `${anchorPosition.right}px`,
              }
              : {
                top: "2rem",
                right: "1.5rem",
              }
          }
        >
          <div className="py-2 px-3">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleMenuItemClick(item.path, item.isExternal)}
                className="w-full flex items-center gap-2 py-1 text-left hover:bg-gray-50 active:bg-gray-100 transition-colors"
              >
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  {item.icon}
                </div>
                <span className="flex-1 text-base font-medium text-black">
                  <FirebaseKey firebaseKey={item.firebaseKey} />
                </span>
                {item.postFix && (
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center">
                    {item.postFix}
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;
